import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Form, Input, message, Popconfirm, Select } from "antd";
import { MdModeEditOutline } from "react-icons/md";
import { editArticleSeo, getArticleByID } from "../action";
import { IArticle } from "../../../types/Article";

type Props = {
  onSeoEdit?: () => void;
};

interface FormData {
  keywords: string[];
  description: string;
}
const EditSEO = (props: Props) => {
  const { onSeoEdit } = props;
  const { id } = useParams();
  const [article, setArticle] = useState<IArticle | null>(null);
  const [form] = Form.useForm<FormData>();
  const [loading, setIsLoading] = useState<boolean>(false);
  const fetchData = async () => {
    if (id) {
      const result = await getArticleByID(id);
      if (result) {
        form.setFieldsValue({
          keywords: result.Seo?.Keywords,
          description: result.Seo?.Description,
        });
        setArticle(result);
      }
    }
  };

  const handleSubmit = async (values: FormData) => {
    setIsLoading(true);
    try {
      const result = await editArticleSeo(
        id!,
        values.keywords,
        values.description
      );
      if (result) {
        message.success("Seo updated successfully");
        onSeoEdit?.();
      }
    } catch (error) {
      message.error("Seo update failed");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <Form form={form} onFinish={handleSubmit} layout="vertical">
      <Form.Item name="keywords" label="Keywords">
        <Select
          mode="tags"
          style={{ width: "100%" }}
          placeholder="Add keywords"
          tokenSeparators={[","]}
        />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea />
      </Form.Item>
      <Popconfirm
        title="Edit Seo"
        description="Are you sure you want to edit seo?"
        onConfirm={() => form.submit()}
        okText="Yes"
        cancelText="No"
      >
        <Button
          type="primary"
          icon={<MdModeEditOutline />}
          loading={loading}
          block
        >
          Edit Seo
        </Button>
      </Popconfirm>
    </Form>
  );
};

export default EditSEO;
